'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _fade = require('../internal/fade');

var _fade2 = _interopRequireDefault(_fade);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  label: {
    fontSize: '16px',
    color: _colors2.default.secondaryText,
    fontWeight: 'bolder',
    marginBottom: '10px',
    display: 'inline-block'
  },
  wrapper: {
    width: '40px',
    height: '20px',
    position: 'relative',
    cursor: 'pointer'
  },
  knob: {
    backgroundColor: _colors2.default.white,
    width: '20px',
    height: '20px',
    boxShadow: _styles2.default.depthShadows[0],
    borderRadius: '50%',
    position: 'absolute',
    top: '0',
    left: '0',
    transition: 'all .3s ease-in-out'
  },
  track: {
    backgroundColor: _colors2.default.grey,
    width: '34px',
    height: '14px',
    position: 'relative',
    top: '3px',
    left: '3px',
    borderRadius: '30px',
    transition: 'all .3s ease-in-out'
  },
  knobActive: {
    backgroundColor: _colors2.default.theme,
    left: '20px'
  },
  trackActive: {
    backgroundColor: (0, _fade2.default)(_colors2.default.theme, 0.5)
  }
};
module.exports = exports.default;